import React, { useContext, useState } from "react";
import styled from "styled-components";
import FormCard from "./components/view-card";
import Button from "../../../../components/button";
import ClientSurveyTable from "./components/client-survey-table";
import { ClientSurveyModal } from "./components/client-survey-modal";
import { ImportSurveyModal } from "./components/import-survey-modal";
import ScheduledAssignmentTable from "./components/scheduled-assignment-table";
import ScheduledAssignmentModal from "./components/scheduled-assignment-modal";

const Title = styled.h2`
  display: flex;
  align-items: center;
  margin: 10px auto 10px auto;
  padding-bottom: 8px;
  color: #181818;
  font-family: "DM Sans", sans-serif;
  font-size: 1.25rem;
  font-weight: 600;

  button {
    margin-left: 16px;
  }
`;

const AddButton = styled(Button)`
  margin: 0;
  min-width: 120px;
`;

const ViewForms = ({ history, forms, setForms, fetchSurveys }) => {
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [selectedUserID, setSelectedUserID] = useState(null);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showScheduledAssignmentModal, setShowScheduledAssignmentModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [selectedScheduleId, setSelectedScheduleId] = useState(null);
  
  const handleEditSchedule = (scheduleId) => {
    setSelectedScheduleId(scheduleId);
    setModalType("edit");
    setShowScheduledAssignmentModal(true);
  };

  const handleCloseModal = () => {
    setShowScheduledAssignmentModal(false);
    setSelectedScheduleId(null);
    setModalType('');
  };
  
  return (
    <div>
      <Title>
        Check-in Forms
        <AddButton
          label="Create Form"
          onClick={() => history.push("/dashboard/forms/create")}
        />
        <AddButton
          label="Import Form"
          onClick={() => setShowImportModal(true)}
        />
      </Title>
      {forms.length === 0 && (
        <p>You have no client check-in forms yet. Click "Create Form" above.</p>
      )}
      {forms.map((form) => (
        <FormCard key={form.id} form={form} forms={forms} setForms={setForms} />
      ))}

      <Title style={{ marginTop: "42px" }}>
        Scheduled Check-in Form Assignments
        <AddButton label="Create Schedule" onClick={() => {setShowScheduledAssignmentModal(true); setModalType("create")}} />
        <ScheduledAssignmentModal
          modalType={modalType}
          forms={forms}
          open={showScheduledAssignmentModal}
          onClose={handleCloseModal}
          selectedScheduleId={selectedScheduleId}
        />

      </Title>
      <ScheduledAssignmentTable
        forms={forms}
        setShowResponseModal={setShowResponseModal}
        setSelectedUserID={setSelectedUserID}
        handleEdit={handleEditSchedule}
      />
      <ClientSurveyTable
        setShowResponseModal={setShowResponseModal}
        setSelectedUserID={setSelectedUserID}
      />
      <ClientSurveyModal
        open={showResponseModal}
        onClose={() => setShowResponseModal(false)}
        clientUserID={selectedUserID}
      />
      <ImportSurveyModal
        open={showImportModal}
        onClose={() => setShowImportModal(false)}
        fetchSurveys={fetchSurveys}
      />
    </div>
  );
};

export default ViewForms;
